module.exports = __webpack_public_path__ + "img/snow_fall_00004.6c7edd0f.png";